export type PublicService = "api" | "minio" | "minioconsole";

const SERVICE_PREFIXES = new Set([
  "admin",
  "app",
  "api",
  "minio",
  "minioconsole",
]);

const IPV4_PATTERN = /^\d{1,3}(?:\.\d{1,3}){3}$/;

export const isLocalHostname = (hostname: string): boolean => {
  const normalizedHostname = hostname.toLowerCase();
  return (
    normalizedHostname === "localhost" ||
    normalizedHostname === "::1" ||
    IPV4_PATTERN.test(normalizedHostname)
  );
};

/**
 * Returns the domain shared by all public services in a deployment.
 *
 * The same application can be reached through a hostname with no service
 * prefix (smartdoc.araitek.com) or through app.<domain>. Both aliases resolve
 * to the same domain-family model at browser runtime.
 */
export const getBaseDomain = (hostname: string): string => {
  const normalizedHostname = hostname.toLowerCase().replace(/\.$/, "");
  const labels = normalizedHostname.split(".");

  if (labels.length > 2 && SERVICE_PREFIXES.has(labels[0])) {
    return labels.slice(1).join(".");
  }

  return normalizedHostname;
};

export const getServiceOrigin = (
  service: PublicService,
  location: Pick<Location, "hostname" | "protocol"> = window.location,
): string => `${location.protocol}//${service}.${getBaseDomain(location.hostname)}`;
